var _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCityLightLeft = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 286,
    height: 182,
    viewBox: "0 0 286 182",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#BBBBC9",
    points: "123.851 2248.642 120 2215.916 132.398 2214.465 131.539 2207.187 143.937 2205.736 134.772 2127.901 139.151 2127.389 138.209 2119.39 167.376 2115.977 168.492 2125.427 179.428 2124.149 191.246 2224.532 201.45 2223.329 189.211 2119.315 196.499 2118.458 195.474 2109.729 218.808 2107 232.336 2221.923 239.625 2221.073 234.402 2176.701 240.235 2176.017 237.929 2156.379 284.597 2150.914 286.564 2167.642 287.076 2172.002 291.455 2171.491 292.819 2183.129 317.842 2138.17 335.772 2127.216 343.904 2196.323 357.757 2194.7 360.244 2215.788 377.013 2213.826 378.212 2224.013 401.546 2221.276 406 2259.1 150.78 2289",
    transform: "translate(-120 -2107)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCityLightLeft, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/city-light-left.58e8b95b.svg";
export { ForwardRef as ReactComponent };